import { Box, Link, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRGBAColor } from '../functions/getRGBAColor';
import { ILayout } from '../interfaces/shared/ILayout';

interface IProps {
  routes: ILayout[] | undefined;
  isCollapsed: boolean;
}
const SidebarItems = ({ isCollapsed, routes }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav
      style={{
        marginTop: '20px',
        transition: 'all 0.4s ease-in-out',
        overflowY: 'auto',
      }}
    >
      {routes?.map(({ path, title, icon }) => {
        return (
          <Link
            key={path}
            onClick={() => navigate(path)}
            className={pathname.includes(path) ? 'active' : ''}
            sx={{
              display: 'flex',
              alignItems: 'center',
              padding: '15px 10px',
              cursor: 'pointer',
              justifyContent: isCollapsed ? 'center' : 'flex-start',
              transition: 'all 0.4s ease-in-out',
              backgroundColor:
                pathname === path
                  ? getRGBAColor('--primaryColor', 0.1)
                  : 'transparent',
              ':hover': {
                backgroundColor: getRGBAColor('--primaryColor', 0.1),
              },
            }}
          >
            {isCollapsed ? (
              <Tooltip title={t(title)} placement="right">
                {icon}
              </Tooltip>
            ) : (
              <>
                {icon}
                <Box sx={{ marginLeft: '10px' }}>{t(title)}</Box>
              </>
            )}
          </Link>
        );
      })}
    </nav>
  );
};

export default SidebarItems;
